import React, {useContext} from 'react';
import {Context} from "../../context/LangContext";
import './Contenu.css';
import data from "../../assets/data";

const Contenu = () => {

    const {lang} = useContext(Context)

    return (
        <div>
            <div className="content">
                <h1 className="title">{data[lang].title}</h1>
                <p className="txt">{data[lang].txt}</p>
            </div>
        </div>
    );
};

export default Contenu;